class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.thumbs;
    this.mainSlider;
    this.productSlider();
    if (Shopify.designMode) {
      window.addEventListener('resize', () => {
        this.resizeChange();
      });
    }
  }

  hideOnDeskTop = () => {
    return document.querySelector('.product__media-list.stacked-media-items') && !isMobile()
  }
  resizeChange = () => {
    if (this.mainSlider) {
      this.mainSlider.destroy();
    }
    if (this.thumbs) {
      this.thumbs.destroy()
    }
    this.productSlider();
  }
  productSlider = () => {

    if (this.hideOnDeskTop()) {
      return;
    }
    let totalSlide = 6;
    let mainPaginationSettings = {};
    if (isMobile()) {
      totalSlide = 4;
      mainPaginationSettings = {
        el: ".swiper-pagination",
        clickable: true
      };;
    }
    let centeredSlides = true;
    let slideToClickedSlide = true;
    let loop = true;
    let lessItems = false;
    let freeMode, watchSlidesProgress, watchSlidesVisibility = false;
    if (this.querySelectorAll('.gallery-thumbs .swiper-slide').length <= totalSlide) {
      this.querySelector('.gallery-thumbs')?.classList.add('less-items');
      lessItems = true;
      centeredSlides = false;
      slideToClickedSlide = false;
      loop = true;
      freeMode = true;
      watchSlidesProgress = true;
      watchSlidesVisibility = true;
    }
    if (this.querySelector('.gallery-thumbs')) {
    this.thumbs = new Swiper(this.querySelector('.gallery-thumbs'), {
      slidesPerView: totalSlide,
      spaceBetween: 10,
      slideToClickedSlide: slideToClickedSlide,
      centeredSlides: centeredSlides,
      loop: loop,
      watchSlidesVisibility: watchSlidesVisibility,
      watchSlidesProgress: watchSlidesProgress,
      freeMode: freeMode
    });
    }
    let mainSlideOptions = {
      slidesPerView: 1,
      loopedSlides: totalSlide,
      loop: loop,
      centeredSlides: centeredSlides,
      pagination: mainPaginationSettings,
      thumbs: { swiper: lessItems ? this.thumbs : null }
    }
    if (isMobile()) {
      mainSlideOptions['autoHeight'] = true
      mainSlideOptions['loop'] = false
      mainSlideOptions['mousewheel'] = {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      }
    }
    setTimeout(() => {
    this.mainSlider = new Swiper(this.querySelector('.product-slider'), mainSlideOptions);
    if (!lessItems) {
      this.mainSlider.controller.control = this.thumbs;
      this.thumbs.controller.control = this.mainSlider;
    }
    }, 500);
  }
}
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery)
}
